// src/app/services/idle.service.ts
import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { CompanyService } from './company/company.service';

@Injectable({
  providedIn: 'root',
})
export class IdleService {
  private timeoutId: any;
  private timeout = 60 * 1000 * 20;
  private user = localStorage.getItem('auth_user')
    ? JSON.parse(localStorage.getItem('auth_user')!)
    : null;

  constructor(
    private readonly router: Router,
    private readonly ngZone: NgZone,
    private readonly companyService: CompanyService
  ) {
    // if (this.user?.companyID) {
    //   this.companyService.getSettingsById(this.user.companyID).subscribe({
    //     next: (resp) => {
    //       if (resp?.data?.idle_time_out) {
    //         this.timeout = 60 * resp.data.idle_time_out * 1000; // multiply by 1000 to convert minutes to ms
    //       }
    //       this.initListener(); // start listening only after timeout is set
    //     },
    //     error: () => {
    //       this.initListener(); // fallback if API fails
    //     },
    //   });
    // } else {
    //   this.initListener(); // fallback if no user
    // }
  }

  initListener() {
    this.resetTimer();
    const events = ['mousemove', 'keydown', 'click', 'touchstart'];
    events.forEach((event) =>
      window.addEventListener(event, this.resetTimer.bind(this))
    );
  }

  resetTimer() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    this.ngZone.runOutsideAngular(() => {
      this.timeoutId = setTimeout(() => {
        this.ngZone.run(() => {
          this.logout();
        });
      }, this.timeout);
    });
  }

  logout() {
    localStorage.clear();
    this.router.navigate(['/']);
  }
}
